import { data } from "./launch.data";
export {
    data
}